/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Prop_Left_TitleInputs */

const cs_builder_prop_left_title = /** @type {(inputs: Builder_Prop_Left_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Levý titul`)
};

const en_builder_prop_left_title = /** @type {(inputs: Builder_Prop_Left_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Left title`)
};

/**
* | output |
* | --- |
* | "Left title" |
*
* @param {Builder_Prop_Left_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_prop_left_title = /** @type {((inputs?: Builder_Prop_Left_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Prop_Left_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_prop_left_title(inputs)
	return cs_builder_prop_left_title(inputs)
});